import React, {Component} from 'react';
import cn from 'classnames';
import './style.css';

export default class Section extends Component {
    render() {
        const {items, className} = this.props;

        const classNames = cn(
            className,
            'Section',
        );

        const list = items.map((item, index) => {
            return (
                <li key={index}>{item}</li>
            );
        });

        return (
            <section className={classNames}>
                <h2 className="Section__title">{this.props.title}</h2>
                <ul className="Section__list">
                    {list}
                </ul>
            </section>
        )
    }
}